module.exports = __webpack_public_path__ + "static/media/Infographic.8d3a9939.png";